import {SpacingArgument} from '@material-ui/core/styles/createSpacing'

import {createTheme} from './createTheme'

/** @deprecated use `spacing`, `breakpoints` from the same path */
const theme = createTheme()
theme.palette.background.default = '#fff'

const {breakpoints} = theme

function spacing(): string
function spacing(value: number): string
function spacing(topBottom: SpacingArgument, rightLeft: SpacingArgument): string
function spacing(top: SpacingArgument, rightLeft: SpacingArgument, bottom: SpacingArgument): string
function spacing(top: SpacingArgument, right: SpacingArgument, bottom: SpacingArgument, left: SpacingArgument): string
function spacing(...args: SpacingArgument[]): string {
  const s: SpacingArgument = theme.spacing(
    // @ts-expect-error 🤷‍️ хз че ему не нравится
    ...args,
  )

  return typeof s === 'number' ? `${s}px` : s
}

function isHexValid(x: unknown): x is [string, string, string, string] {
  return x !== null
}

function hex2rgba(hex: string, alpha: number = 1): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return isHexValid(result)
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})`
    : ''
}

function darken(hex: string, amount: number = 1): string {
  const rgba = hex2rgba(hex)
  const [red, green, blue] = rgba.match(/\d+/g) || []
  const decrease = (value: string) => Math.floor((1 - amount) * Number(value))

  if (!red || !green || !blue || amount > 1) {
    return hex
  }

  return `rgb(${decrease(red)}, ${decrease(green)}, ${decrease(blue)})`
}

// чтобы можно было юзать theme.breakpoints.down('sm')
// todo переделать на Breakpoints | string
function isMatchMedia(query: string): boolean {
  return window.matchMedia(query.replace(/^@media( ?)/m, '')).matches;
}

export {breakpoints, darken, hex2rgba, isMatchMedia, spacing, theme}
